const DiscoveryIcon = () => {
  return (
    <svg
      className="animate-icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 111 111"
      shapeRendering="geometricPrecision"
      style={{
        position: 'absolute',
        width: '109px',
        height: '109px',
        bottom: -6,
        right: -7,
        transition: 'opacity 0.25s ease-in-out',
      }}
    >
      <path
        d="M110 55.5C110 85.5995 85.5995 110 55.5 110C25.4005 110 1 85.5995 1 55.5C1 25.4005 25.4005 1 55.5 1C85.5995 1 110 25.4005 110 55.5Z"
        fill="#fff"
        stroke="#2d426a"
        strokeWidth={2}
      />
      <path
        className="animate-compass"
        d="M87.1689 26.508C88.2319 23.2454 84.963 20.2466 81.804 21.5863L45.5734 36.9512C41.8602 38.5259 39.0065 41.6257 37.7435 45.4562L24.869 84.5039C23.7947 87.7624 27.0521 90.7725 30.2158 89.4448L66.5283 74.2053C70.2803 72.6307 73.1615 69.5017 74.422 65.6329L87.1689 26.508Z"
        fill="#5bd992"
        stroke="#2d426a"
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <circle
        cx="56.5093"
        cy="55.5001"
        r="10.1019"
        fill="#fff"
        stroke="#2d426a"
        strokeWidth={2}
      />
    </svg>
  );
};

export default DiscoveryIcon;
